import React from "react";
import { OutboundLink } from "gatsby-plugin-google-gtag";

export const Discord = () => {
  const handleClick = () => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "click", {
        event_category: "discord_link",
        event_label: "Kanał Discord - Lempiank",
      });
    }
  };

  return (
    <div>
      <OutboundLink
        href="https://discord.com/invite/lempiank"
        target="_blank"
        onClick={handleClick}
        rel="noreferrer nofollow"
        className="flex h-8 w-8 cursor-pointer  items-center justify-center fill-gray_icons hover:fill-post_likes_font_color dark:fill-white dark:hover:fill-post_likes_font_color"
        title="Kanał Discord - Lempiank"
      >
        <svg
          width="20"
          height="16"
          viewBox="0 0 20 16"
          xmlns="http://www.w3.org/2000/svg"
          className=""
          loading="lazy"
        >
          <path d="M16.4117 2.12725C18.4937 5.20726 19.5219 8.68142 19.1375 12.681C19.1359 12.6979 19.1271 12.7134 19.1133 12.7236C17.5367 13.8885 16.0092 14.5954 14.5031 15.0643C14.4913 15.0678 14.4788 15.0676 14.4672 15.0637C14.4556 15.0597 14.4455 15.0522 14.4383 15.0422C14.0903 14.5551 13.7742 14.0415 13.4972 13.5022C13.4813 13.4705 13.4958 13.4322 13.5286 13.4197C14.0307 13.2293 14.5081 13.0012 14.9674 12.7311C15.0036 12.7097 15.0059 12.6576 14.9724 12.6325C14.875 12.5597 14.7784 12.4832 14.686 12.4067C14.6687 12.3925 14.6455 12.3898 14.6259 12.3993C11.6443 13.7846 8.37815 13.7846 5.36132 12.3993C5.34173 12.3905 5.31846 12.3935 5.30164 12.4074C5.20946 12.4839 5.11268 12.5597 5.01613 12.6325C4.98272 12.6576 4.98548 12.7097 5.02189 12.7311C5.48114 12.9961 5.9586 13.2293 6.46002 13.4206C6.49251 13.4331 6.50795 13.4705 6.49182 13.5022C6.22083 14.0422 5.90468 14.5558 5.55027 15.0429C5.53484 15.0626 5.50949 15.0717 5.48552 15.0643C3.98656 14.5954 2.45902 13.8885 0.882396 12.7236C0.869262 12.7134 0.859814 12.6972 0.858431 12.6803C0.537208 9.22072 1.19187 5.71781 3.58169 2.12655C3.58745 2.11705 3.5962 2.10963 3.60634 2.10522C4.78224 1.56221 6.04202 1.16272 7.35871 0.934571C7.38268 0.930861 7.40664 0.941991 7.41908 0.963322C7.58177 1.25314 7.76773 1.62481 7.89355 1.92855C9.28144 1.71524 10.691 1.71524 12.1079 1.92855C12.2337 1.63131 12.4133 1.25314 12.5753 0.963322C12.581 0.95274 12.59 0.944262 12.6008 0.939099C12.6116 0.933935 12.6238 0.932351 12.6356 0.934571C13.953 1.16342 15.2128 1.56291 16.3878 2.10522C16.3981 2.10963 16.4067 2.11705 16.4117 2.12725V2.12725ZM8.59913 8.70507C8.61365 7.68234 7.87258 6.83606 6.94232 6.83606C6.01967 6.83606 5.28574 7.67492 5.28574 8.70507C5.28574 9.73499 6.03418 10.5738 6.94232 10.5738C7.8652 10.5738 8.59913 9.73499 8.59913 8.70507V8.70507ZM14.7245 8.70507C14.739 7.68234 13.9979 6.83606 13.0679 6.83606C12.145 6.83606 11.4111 7.67492 11.4111 8.70507C11.4111 9.73499 12.1595 10.5738 13.0679 10.5738C13.9979 10.5738 14.7245 9.73499 14.7245 8.70507V8.70507Z" />
        </svg>
      </OutboundLink>
    </div>
  );
};
